import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const style = () => ({
    root: {
        maxWidth: 600,
        margin: 'auto',
    },
});

class NoMatch extends Component {
    render() {
        return (
            <Card className={this.props.classes.root}>
                <CardHeader title="Page Not Found"/>
                <CardContent>
                    <Typography paragraph>
                        Sorry. It seems likes this page does not exist. <Link to="/">Click here to go to home.</Link>
                    </Typography>
                </CardContent>
            </Card>
        );
    }
}

NoMatch.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
    }).isRequired,
};

export default withStyles(style)(NoMatch);